import styled from 'styled-components';
export var Iframe = styled.iframe.withConfig({
  displayName: "partials__Iframe",
  componentId: "sc-1w2a3qp-0"
})(["width:100%;border:1px solid ", ";border-radius:", ";margin-top:10px;margin-bottom:10px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.uiM;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
});